import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { IEmpresas } from "../../interfaces/IEmpresas";
import { IRegimeTributario } from "../../interfaces/IRegimeTributario";
import RegimeTributarioService from "../../services/RegimeTributarioService";
import RegimeNovoModalTabela from "./RegimeNovoModalTabela";
import clsx from "clsx";
import { FormikProps } from 'formik';
import Swal from 'sweetalert2';
import { IEmpresaRegimeTributario } from "../../interfaces/IEmpresaRegimeTributario";
import EmpresaRegimeTributarioService from "../../services/EmpresaRegimeTributarioService";
/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
function RegimeNovoModal({ empresa, setEmpresa, abaSelecionada, formikRegimeTributario }: { empresa: IEmpresas, abaSelecionada: string, formikRegimeTributario: FormikProps<IEmpresaRegimeTributario>, setEmpresa: Dispatch<SetStateAction<IEmpresas | null>> }) {
    const { t } = useTranslation();
    const [carregado, setCarregado] = useState<boolean>(false);
    const [regimesTributarios, setRegimesTributarios] = useState<IRegimeTributario[]>([]);
    const columns = [
        {
            name: t('Regime Tributário'),
            selector: (row: IEmpresaRegimeTributario) => row['regimeTributario'].nome,
            sortable: true
        },
        {
            name: t('Ano de opção'),
            selector: (row: IEmpresaRegimeTributario) => row['anoOpcao'],
            sortable: true
        },
        {
            name: t('Data de registro'),
            selector: (row: IEmpresaRegimeTributario) => row['dataString'],
            sortable: true
        },
        {
            name: t('Ações'),
            cell: (row: IEmpresaRegimeTributario) => <AcoesRegras excluirRegime={excluirRegime} item={row} />
        }
    ];

    useEffect(() => {
        formikRegimeTributario.setFieldTouched('anoOpcao', false);
        formikRegimeTributario.setFieldTouched('regimeTributarioID', false);

        async function preCarregar() {
            setCarregado(false);

            try {
                var todosRegimesTributarios = await RegimeTributarioService.obterTodos();

                setRegimesTributarios(todosRegimesTributarios);
            } catch (error) {
                console.log('Não foi possivel carregar os regimes iniciais')
                console.log(error);
            }

            setCarregado(true);
        }

        preCarregar();
        // eslint-disable-next-line
    }, [])

    function AcoesRegras({ item, excluirRegime }: { item: IEmpresaRegimeTributario, excluirRegime: (regras: IEmpresaRegimeTributario) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => excluirRegime(item)} className="fas fa-trash-alt fa-lg" style={{ color: '#5E6397', marginLeft: '25px', fontWeight: 'normal', cursor: 'pointer' }} />
        </div>
    }

    async function excluirRegime(empresaRegimeTributario: IEmpresaRegimeTributario) {
        try {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-modal-excluir ms-5',
                    cancelButton: 'btn btn-modal-cancelar'
                },
                buttonsStyling: false
            });
            const result = await swalWithBootstrapButtons.fire({
                title: t('Excluir Regime'),
                text: t(`Você realmente deseja excluir esse regime?`),
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: `Excluir`,
                reverseButtons: true
            });

            if (result.isConfirmed) {
                await EmpresaRegimeTributarioService.excluir(empresaRegimeTributario.id);

                let regimesEmpresas = (empresa.empresaRegimesTributarios ?? []).filter(x => x.id !== empresaRegimeTributario.id)

                setEmpresa({ ...empresa, empresaRegimesTributarios: regimesEmpresas });

                await Swal.fire({
                    title: '',
                    text: t('Excluido'),
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000,
                })
            }
        } catch (error) {
            Swal.fire({
                text: t('Não foi possivel excluir o regime'),//error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    return <>
        <div style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px', minHeight: '505px', display: abaSelecionada === '2' ? 'block' : 'none' }}>
            <div style={{ display: 'flex', paddingBottom: '30px' }}>
                <div className="col-md-5">
                    <label htmlFor="form-regime" className="form-label required">{t("Regime Tributário")}</label>
                    <select placeholder={t("Selecione")} id="form-regime"
                        {...formikRegimeTributario.getFieldProps('regimeTributarioID')}
                        className="form-select">
                        <option value="" hidden>{t("Selecione")}</option>
                        {
                            regimesTributarios.length > 0 && regimesTributarios.map((x, index) => <option key={index} value={x.id}>{x.nome}</option>)
                        }
                    </select>
                </div>
                <div className="col-md-2">
                    <label htmlFor="form-ano" className="form-label required">{t("Ano de opção")}</label>
                    <input {...formikRegimeTributario.getFieldProps('anoOpcao')} placeholder={t("Digite Algo")} className={clsx(
                        'form-control',
                        {
                            'is-invalid': formikRegimeTributario.touched.anoOpcao && formikRegimeTributario.errors.anoOpcao
                        },
                        {
                            'is-valid': formikRegimeTributario.touched.anoOpcao && !formikRegimeTributario.errors.anoOpcao
                        }
                    )} id="form-ano" />
                </div>
                <button disabled={formikRegimeTributario.isSubmitting || !formikRegimeTributario.isValid} onClick={() => formikRegimeTributario.submitForm()} style={{ height: '40px', marginTop: '27px' }} className='btn btn-sm btn-primario'><i className="icon-lg text-white fas fa-plus"></i></button>
            </div>
            {
                carregado ? (empresa.empresaRegimesTributarios ?? []).length > 0 ? <RegimeNovoModalTabela colunas={columns} itens={empresa.empresaRegimesTributarios} /> : <h2>{t("Não possuem Regimes vinculado a essa Empresa")}</h2> : <h2>{t("Carregando...")}</h2>
            }
        </div>
    </>
};

export default RegimeNovoModal;